import React, { useEffect } from 'react';
import { Form } from 'antd';
import { createSearchParams, Link } from 'react-router-dom';
import ChooseSeatFormation from './components/ChooseSeatFormation';
import DefaultButton from '../../../../components/buttons/defaultButton/DefaultButton';
import { useAuth } from '../../../../../contexts/userContext/userContext';
import { useModal } from '../../../../../contexts/modalsContext/modalsContext';
import ChosenRideDetails
  from '../../../../components/drawers/ticketSearchDrawers/ticketSearchFormDrawer/components/ChosenRideDetails';
import useTranslation from '../../../../../hooks/translation/useTranslation';
import useQuery from '../../../../../hooks/useQuery';

function SearchRidesForm({
  chosenRides, seatFormationForm, className, rideSearchForm, guid,
}) {
  const query = useQuery();
  const standard = Form.useWatch('standard_passengers', rideSearchForm);
  const disabled = Form.useWatch('disabled_passengers', rideSearchForm);
  const child = Form.useWatch('child_passengers', rideSearchForm);
  const seatFormation = Form.useWatch('seatFormation', seatFormationForm);
  const { accessToken } = useAuth();
  const { setShowAuthModal, setShowTicketSearchDrawer } = useModal();
  const { trans } = useTranslation();

  useEffect(() => {
    if (standard + child + disabled > 9) {
      seatFormationForm.setFieldValue('seatFormation', 'book');
    } else if (seatFormationForm.getFieldValue('seatFormation') === 'book') {
      seatFormationForm.setFieldValue('seatFormation', 'auto');
    }
  }, [standard, disabled, child]);

  const isDisabled = () => {
    if (!chosenRides?.departure?.id) {
      return true;
    }

    if (query.get('returnDateFrom') && !chosenRides?.return?.id) {
      return true;
    }

    return standard + disabled + child === 0;
  };

  return (
    <Form className={className} initialValues={{ seat_formation: 'auto' }} form={seatFormationForm}>
      <div className="w-full lg:min-w-[400px] lg:max-w-[400px] md:p-8 rounded-2xl flex flex-col gap-[28px] h-fit sticky top-[136px] bg-[white]">
        <div className="h-full w-full absolute left-0 top-0 pointer-events-none hidden lg:block">
          <div className="h-full w-full z-10 outline-border" />
        </div>
        <h2 className="font-big-bold text-primary text-2xl">{trans('chosen_tickets')}</h2>
        <ChosenRideDetails chosenRide={chosenRides?.departure} />
        <ChosenRideDetails chosenRide={chosenRides?.return} />
        <ChooseSeatFormation
          chosenRides={chosenRides}
          seatFormation={seatFormation}
          totalPassengers={standard + disabled + child}
        />
        <div className="h-[1px] bg-gray-gr w-full opacity-30" />
        {accessToken
          ? (
            <Link
              className="text-white hover:text-white h-full w-full"
              to={`booking?${createSearchParams({
                seatFormation,
                guid,
              })}`}
              onClick={() => {
                setShowTicketSearchDrawer(false);
              }}
            >
              <DefaultButton
                className="text-base cursor-pointer w-full"
                type="submit"
                disabled={isDisabled()}
              >
                {trans('continue')}
              </DefaultButton>
            </Link>
          ) : (
            <DefaultButton
              className="text-base cursor-pointer w-full"
              type="submit"
              disabled={isDisabled()}
              onClick={() => {
                setShowTicketSearchDrawer(false);
                setShowAuthModal(true);
              }}
            >
              {trans('continue')}
            </DefaultButton>
          )}
        <div className="flex gap-4">
          <p className="text-xs font-bold">
            {trans('sum_price_text')}
          </p>
        </div>
      </div>
    </Form>
  );
}

export default SearchRidesForm;
